import styled from 'styled-components';

const StyledRelationCodeSelect = styled.div`
   max-width: 250px;
`;
StyledRelationCodeSelect.displayName = 'StyledRelationCodeSelect';

export { StyledRelationCodeSelect };
